// Word Bomb Party Client
import { sounds } from '../sound.js';

export class WordBombClient {
  constructor(socket, containerEl) {
    this.socket = socket;
    this.container = containerEl;
    this.isMyTurn = false;

    this.render();
    this.setupSocketEvents();
  }

  render() {
    this.container.innerHTML = `
      <div class="wb-wrapper">
        <div class="wb-header">
          <h2>💣 WORD BOMB PARTY</h2>
          <div id="wb-status" class="wb-badge">PASS THE BOMB!</div>
        </div>

        <!-- Bomb Display & Prompt -->
        <div class="wb-bomb-container">
          <div class="wb-bomb" id="wb-bomb-icon">
            <span class="bomb-emoji">💣</span>
            <div class="bomb-fuse" id="wb-fuse"></div>
          </div>
          
          <div class="wb-prompt-box">
            <div class="prompt-label">CONTAINING LETTERS:</div>
            <div class="prompt-letters" id="wb-letters">STR</div>
            <div class="wb-timer" id="wb-timer">⏳ 7.0s</div>
          </div>
        </div>

        <!-- Word Input Bar -->
        <div class="wb-input-area" id="wb-input-box">
          <input type="text" id="wb-word-input" placeholder="Type a word containing the letters..." autocomplete="off" />
          <button id="wb-btn-submit" class="btn-action">SUBMIT</button>
        </div>

        <!-- Error / Alert Message -->
        <div id="wb-msg" class="wb-msg-alert"></div>
      </div>
    `;

    const input = document.getElementById('wb-word-input');
    const send = () => {
      if (!this.isMyTurn) return;
      const word = input.value.trim();
      if (!word) return;
      this.socket.emit('wb_submit', { word });
      input.value = '';
    };

    document.getElementById('wb-btn-submit')?.addEventListener('click', send);
    input?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') send();
    });
  }

  setupSocketEvents() {
    this.socket.on('wb_newTurn', (data) => {
      this.isMyTurn = data.playerId === this.socket.id;
      sounds.playTick();

      const status = document.getElementById('wb-status');
      const letters = document.getElementById('wb-letters');
      const input = document.getElementById('wb-word-input');
      const box = document.getElementById('wb-input-box');
      const msg = document.getElementById('wb-msg');
      if (msg) msg.innerText = '';

      if (letters) letters.innerText = data.prompt;
      if (status) status.innerText = this.isMyTurn ? '🔥 YOUR TURN! TYPE FAST!' : `Bomb passed to ${data.playerName}`;

      if (box && input) {
        if (this.isMyTurn) {
          box.classList.remove('disabled');
          input.focus();
        } else {
          box.classList.add('disabled');
        }
      }
    });

    this.socket.on('wb_tick', (data) => {
      const timer = document.getElementById('wb-timer');
      if (timer) timer.innerText = `⏳ ${data.timer}s`;
    });

    this.socket.on('wb_wordSuccess', (data) => {
      sounds.playSuccess();
      const msg = document.getElementById('wb-msg');
      if (msg) {
        msg.style.color = '#22c55e';
        msg.innerText = `✅ Accepted: "${data.word}"!`;
      }
    });

    this.socket.on('wb_exploded', (data) => {
      sounds.playExplosion();
      const bomb = document.getElementById('wb-bomb-icon');
      if (bomb) {
        bomb.classList.add('shake');
        setTimeout(() => bomb.classList.remove('shake'), 600);
      }
      const msg = document.getElementById('wb-msg');
      if (msg) {
        msg.style.color = '#ef4444';
        msg.innerText = `💥 BOOM! ${data.playerName} ran out of time! (Lives: ${data.livesLeft})`;
      }
    });

    this.socket.on('wb_gameOver', (data) => {
      sounds.playVictory();
      alert(`🏆 GAME OVER: ${data.winner?.name || 'Player'} is the Last Survivor!`);
    });
  }

  destroy() {
    this.socket.off('wb_newTurn');
    this.socket.off('wb_tick');
    this.socket.off('wb_wordSuccess');
    this.socket.off('wb_exploded');
    this.socket.off('wb_gameOver');
  }
}
